/**
 * @description Storage function to clear only sensitive data from the local storage without degrade user UX experience.
 *
 */
export const clearSenstiveDataFromLocalStorage = () => {
    localStorage.removeItem("loggedInUserTokensByByLaw");
    localStorage.removeItem("session");
    localStorage.removeItem("sessionExpOn");
    localStorage.removeItem("username");
}